export default "__VITE_ASSET__Dju5hfcu__"